import { MouseEvent } from 'react';
import { useToggle } from 'react-use';
import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { ColumnSettingsModal } from 'src/modals/ColumnSettings/ColumnSettings';
import { LayoutIcon, PlusIcon } from 'src/svgs';
import { PlusIconV2 } from 'src/svgs/PlusIconV2';
import { CustomSalesColumn } from 'src/utils/columns/sales/salesCustomColumnUtils.types';
import { ContentId } from 'src/utils/constants/contentId';
import { SectionType } from 'src/utils/types/sectionType';

export const RecentSalesTableColumnPicker = ({
  variant,
}: {
  variant?: 'compact';
}) => {
  const [isColumnModalOpen, toggleColumnModal] = useToggle(false);
  const onColumnSettingButtonClickHandler = (
    e: MouseEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation();
    if (!isColumnModalOpen) toggleColumnModal(true);
  };

  return (
    <>
      <Stack justifyContent="end">
        {variant === 'compact' ? (
          <Button
            variant="textPlain"
            onClick={onColumnSettingButtonClickHandler}
            style={{ padding: vars.spacing.xs, paddingRight: 0 }}
          >
            <PlusIconV2 size={vars.iconSize.l} />
          </Button>
        ) : (
          <Button
            variant="textPlain"
            onClick={onColumnSettingButtonClickHandler}
          >
            <LayoutIcon size={vars.iconSize.m} />
            <Content id={ContentId.Columns} />
          </Button>
        )}
      </Stack>
      {isColumnModalOpen ? (
        <ColumnSettingsModal<CustomSalesColumn>
          onClose={toggleColumnModal}
          sectionType={SectionType.RecentSalesTable}
        />
      ) : null}
    </>
  );
};
